import { useMutation } from '@tanstack/react-query';
import { ApiResponse } from '../../common/types';
import axiosInstance from '../../utils/axiosInstance';

export type FeedbackPriority = 'P1' | 'P2' | 'P3';

export interface FeedbackSubmission {
  priority: FeedbackPriority;
  title: string;
  description: string;
  reporter_email: string;
  source_url: string;
}

export interface FeedbackSubmissionResponse {
  id: number;
  jira_issue_key: string;
}

export const useSubmitFeedback = () =>
  useMutation({
    mutationFn: async (
      submission: FeedbackSubmission,
    ): Promise<FeedbackSubmissionResponse> => {
      const response = await axiosInstance.post<
        ApiResponse<FeedbackSubmissionResponse>
      >('/api/feedback/', submission);
      if (!response.data.success) {
        throw new Error(
          response.data.error?.message || 'Failed to submit feedback',
        );
      }
      return response.data.data;
    },
  });
